import React from "react";

import preprocessorQuery from "../../utils/preprocessorQuery";
import FocusedPopover from "../popover/FocusedPopover";
import { asPortalChild } from "./asPortalChild";

const defaultPopoverOptions = {
  className: null,
  placement: "bottom-start",
  hideArrow: true,
  isOpen: true,
  target: null,
  toggle: null,
  boundariesElement: null
};

export const popoverOrPortal = (children, popoverOptions, alwaysPortal = false, disableTabLock) => {
  const options = Object.assign({}, defaultPopoverOptions, popoverOptions);
  const isMobile = preprocessorQuery.isMobile();

  const isPortal = isMobile || alwaysPortal;

  if (isPortal) {
    return popoverOptions.isOpen ? asPortalChild(<div className={options.className}>{children}</div>) : null;
  }

  return (
    <FocusedPopover
      className={options.className}
      placement={options.placement}
      hideArrow={options.hideArrow}
      isOpen={options.isOpen}
      target={options.target}
      toggle={options.toggle}
      boundariesElement={options.boundariesElement}
      trigger="legacy"
      disableTabLock={disableTabLock}
    >
      {children}
    </FocusedPopover>
  );
};
